import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useNavigate } from "react-router-dom";
import Select from 'react-select';
import { toast } from 'react-toastify';

const PayoutEdit = ({ close, payoutId }) => {
    

    const [formData, setFormData] = useState({
        customer_id: payoutId?.customer_id,
        active_plan_id: payoutId?.active_plan_id,
        month: payoutId?.month,
        amount: payoutId?.amount,
        remark: payoutId?.remark,
    });

    const navigate = useNavigate();
    const [validation, setvalidation] = useState([])
    const [plan, SetPlan] = useState([])
    const [customerId, setCustomerId] = useState([])
    const [planMonth, setMonth] = useState([])

    const handleChange = async (e) => {
        const { name, value } = e.target;


        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));

        if (name === "active_plan_id") {
            try {
                const token = localStorage.getItem("token");
                const headers = { Authorization: `Bearer ${token}` };

                const response = await axios.get(`public/api/plans/${value}`, { headers });

                setMonth(response?.data?.plan_amounts)

            } catch (error) {
                if (error.response && error.response.status === 401) {
                    localStorage.removeItem("token");
                    navigate("/");
                } else {
                    console.error("Error fetching plan:", error);
                }
            }
        }
    };

    const handleChangeData = (selectedOption) => {
        setFormData((prevState) => ({
            ...prevState,
            customer_id: selectedOption ? selectedOption.value : null, // single value
        }));
    };


    const fetchData = async () => {
        try {
            const token = localStorage.getItem("token");
            const headers = { Authorization: `Bearer ${token}` };
            const [plansRes, customersRes, payoutData,plan ] = await Promise.all([
                axios.get("public/api/plans/list", { headers }),
                axios.get("public/api/customers/filter/list", { headers }),
                axios.get(`public/api/customer-payouts/${payoutId.id}`, { headers }),
                axios.get(`public/api/plans/${payoutId?.active_plan_id}`, { headers }),
            ]);     
            console.log(plan)
            setMonth(plan?.data?.plan_amounts)
            setFormData({
                ...formData,
                customer_id: payoutData?.data?.customer_id,
                active_plan_id: payoutData?.data?.active_plan_id,
                month: payoutData?.data?.month,
                amount: payoutData?.data?.amount,
            })
            SetPlan(plansRes?.data);
            setCustomerId(customersRes?.data?.data);
        } catch (error) {
            if (error.response && error.response.status === 401) {
                localStorage.removeItem("token");
                navigate("/");
            }
        }
    }

    useEffect(() => {
        fetchData()
    }, [])


    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const token = localStorage.getItem("token");
            if (!token) {
                throw new Error("No token found");
            }
            const response = await axios.put(`public/api/customer-payouts/${payoutId.id}`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });

                toast.success(response.data.message);
                close()


        } catch (error) {
            if (error.response && error.response.status === 401) {
                localStorage.removeItem("token");
                navigate("/");
            }
            setvalidation(error.response.data);
        }
    }


    const options = customerId?.map((item) => ({
        label: item.name,
        value: item.id
    }));

    return (
        <div>
            <div className='p-6'>
                <div className="flex items-center justify-end  w-full">
                    <button
                        onClick={close}
                        className="text-gray-500 hover:text-gray-700 focus:outline-none"
                    >
                        <svg
                            className="w-6 h-6"
                            fill="none"
                            stroke="black"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M6 18L18 6M6 6l12 12"
                            ></path>
                        </svg>
                    </button>
                </div>
                <div className='flex flex-col items-center mt-6  '>


                    <div className="bg-blue-500 text-white p-3  rounded-full">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="40" height="40" color="#000000" fill="none">
                            <path d="M18.5 20V17.9704C18.5 16.7281 17.9407 15.5099 16.8103 14.9946C15.4315 14.3661 13.7779 14 12 14C10.2221 14 8.5685 14.3661 7.18968 14.9946C6.05927 15.5099 5.5 16.7281 5.5 17.9704V20" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                            <circle cx="12" cy="7.5" r="3.5" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></circle>
                        </svg>
                    </div>
                    <h1 className='text-3xl font-bold mt-4'>Update PayOut </h1>

                    <p className="text-gray-600 mt-2 text-center">
                        Complete the form below to add a new Customer to your chit fund.
                        All fields marked with <span className="text-red-500">*</span> are required.
                    </p>
                </div>
                <div className=' border-b-2 mt-4 '></div>

                <form onSubmit={handleSubmit}>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 mt-4 gap-6">

                        <div>
                            <label htmlFor="phone"
                                className="block text-sm font-medium text-gray-700 flex items-center gap-2"
                            >

                                <span className='border bg-red-100 rounded-full p-1'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" color="#bd10e0" fill="none">
                                        <defs />
                                        <path fill="currentColor" d="M5.993,12.781 C4.748,10.564 5.068,7.706 6.954,5.82 L9.82,2.954 C12.092,0.682 15.775,0.682 18.046,2.954 C20.318,5.225 20.318,8.908 18.046,11.18 L18.007,11.219 C19.252,13.436 18.932,16.294 17.046,18.18 L14.18,21.046 C11.908,23.318 8.225,23.318 5.954,21.046 C3.682,18.775 3.682,15.092 5.954,12.82 Z M10.881,4.014 L8.014,6.881 C6.329,8.566 6.329,11.3 8.014,12.986 C9.7,14.672 12.434,14.672 14.119,12.986 L14.326,12.779 C14.619,12.486 15.094,12.486 15.387,12.779 C15.68,13.072 15.68,13.547 15.387,13.839 L15.18,14.046 C12.908,16.318 9.225,16.318 6.954,14.046 C6.937,14.029 6.92,14.012 6.904,13.995 C5.329,15.689 5.366,18.338 7.014,19.986 C8.7,21.671 11.434,21.671 13.119,19.986 L15.986,17.119 C17.671,15.434 17.671,12.7 15.986,11.014 C14.3,9.329 11.566,9.329 9.881,11.014 L9.674,11.221 C9.381,11.514 8.906,11.514 8.613,11.221 C8.32,10.928 8.32,10.453 8.613,10.161 L8.82,9.954 C11.092,7.682 14.775,7.682 17.046,9.954 C17.063,9.971 17.08,9.987 17.096,10.005 C18.671,8.312 18.634,5.662 16.986,4.014 C15.3,2.329 12.566,2.329 10.881,4.014 Z" />
                                    </svg>
                                </span>
                                Plan {""}
                                <span className='text-lg'> *</span>
                            </label>
                            <div className="mt-2">
                                <select
                                    id="active_plan_id"
                                    name="active_plan_id"
                                    value={formData.active_plan_id}
                                    onChange={handleChange}
                                    autoComplete="active_plan_id"
                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                >
                                    <option >Select Plan</option>
                                    {plan?.map((type) => (
                                        <option key={type.id} value={type.id}>
                                            {type.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <p className="text-red-600 text-sm mt-1">{validation.errors?.active_plan_id}</p>
                        </div>

                        <div>
                            <label htmlFor="name" className="block text-sm font-medium text-gray-700 flex items-center gap-2">
                                <span className='border bg-blue-100 rounded-full p-1'>


                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" color="#d0021b" fill="none">
                                        <path d="M15.5 11C15.5 9.067 13.933 7.5 12 7.5C10.067 7.5 8.5 9.067 8.5 11C8.5 12.933 10.067 14.5 12 14.5C13.933 14.5 15.5 12.933 15.5 11Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M15.4827 11.3499C15.8047 11.4475 16.1462 11.5 16.5 11.5C18.433 11.5 20 9.933 20 8C20 6.067 18.433 4.5 16.5 4.5C14.6851 4.5 13.1928 5.8814 13.0173 7.65013" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M10.9827 7.65013C10.8072 5.8814 9.31492 4.5 7.5 4.5C5.567 4.5 4 6.067 4 8C4 9.933 5.567 11.5 7.5 11.5C7.85381 11.5 8.19535 11.4475 8.51727 11.3499" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M22 16.5C22 13.7386 19.5376 11.5 16.5 11.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M17.5 19.5C17.5 16.7386 15.0376 14.5 12 14.5C8.96243 14.5 6.5 16.7386 6.5 19.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M7.5 11.5C4.46243 11.5 2 13.7386 2 16.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>

                                </span>  Customer Name  <span className='text-lg'> *</span>
                            </label>

                            <div className="mt-2">
                                <Select
                                    label="Customer Name"
                                    name="customer_id"
                                    options={options}
                                    onChange={handleChangeData}
                                    value={options?.find(opt => opt.value === formData.customer_id)}  // convert back for display
                                    isSearchable

                                />
                            </div>
                            <p className="text-red-600 text-sm mt-1">{validation.errors?.customer_id}</p>
                        </div>


                        
                            <div>
                                <label htmlFor="email" className="block text-sm font-medium text-gray-700 flex items-center gap-2">
                                    <span className='border bg-red-100 rounded-full p-1'>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" color="#f5a623" fill="none">
                                            <path d="M2 6L8.91302 9.91697C11.4616 11.361 12.5384 11.361 15.087 9.91697L22 6" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
                                            <path d="M2.01577 13.4756C2.08114 16.5412 2.11383 18.0739 3.24496 19.2094C4.37608 20.3448 5.95033 20.3843 9.09883 20.4634C11.0393 20.5122 12.9607 20.5122 14.9012 20.4634C18.0497 20.3843 19.6239 20.3448 20.7551 19.2094C21.8862 18.0739 21.9189 16.5412 21.9842 13.4756C22.0053 12.4899 22.0053 11.5101 21.9842 10.5244C21.9189 7.45886 21.8862 5.92609 20.7551 4.79066C19.6239 3.65523 18.0497 3.61568 14.9012 3.53657C12.9607 3.48781 11.0393 3.48781 9.09882 3.53656C5.95033 3.61566 4.37608 3.65521 3.24495 4.79065C2.11382 5.92608 2.08114 7.45885 2.01576 10.5244C1.99474 11.5101 1.99475 12.4899 2.01577 13.4756Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
                                        </svg>
                                    </span> Month
                                </label>
                                {/* <input
                                id="month"
                                name="month"
                                type="month"
                                placeholder="Enter email"
                                value={formData.month}
                                onChange={handleChange}
                                className="mt-2 block w-full rounded-md border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                            /> */}

                                <div className="mt-2">
                                    <select
                                        id="month"
                                        name="month"
                                        value={formData.month}
                                        onChange={handleChange}
                                        autoComplete="month"
                                        className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                    >
                                        <option >Select Plan</option>

                                        {planMonth?.map((type) => (
                                            <option key={type.id} value={type.month}>
                                                {type.month}-₹{type.payable_amount}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <p className="text-red-600 text-sm mt-1">{validation.errors?.month}</p>
                            </div>
                     


                        <div className=''>
                            <label htmlFor="address" className="block text-sm font-medium text-gray-700 flex items-center gap-2">



                                <span className='border bg-green-100 rounded-full p-1'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" color="#7ed321" fill="none">
                                        <path d="M9.06165 4.82633L3.23911 9.92134C2.7398 10.3583 3.07458 11.1343 3.76238 11.1343C4.18259 11.1343 4.52324 11.4489 4.52324 11.8371V15.0806C4.52324 17.871 4.52324 19.2662 5.46176 20.1331C6.40029 21 7.91082 21 10.9319 21H13.0681C16.0892 21 17.5997 21 18.5382 20.1331C19.4768 19.2662 19.4768 17.871 19.4768 15.0806V11.8371C19.4768 11.4489 19.8174 11.1343 20.2376 11.1343C20.9254 11.1343 21.2602 10.3583 20.7609 9.92134L14.9383 4.82633C13.5469 3.60878 12.8512 3 12 3C11.1488 3 10.4531 3.60878 9.06165 4.82633Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M12 16H12.009" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </span> Amount
                            </label>
                            <input
                                id="amount"
                                name="amount"
                                type="number"
                                placeholder="Enter Amount"
                                value={formData.amount}
                                onChange={handleChange}
                                className="mt-2 block w-full rounded-md border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                            />
                            <p className="text-red-600 text-sm mt-1">{validation.errors?.amount}</p>
                        </div>
                           <div className="">
                        <label
                            htmlFor="amount"
                            className="block text-sm font-medium text-gray-700 flex items-center gap-2"
                        >
                            <span className="border bg-green-100 rounded-full p-1">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    width="18"
                                    height="18"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="text-green-600"
                                >
                                    <path d="M21 15a4 4 0 0 1-4 4H7l-4 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4z" />
                                    <path d="M8 9h8" />
                                    <path d="M8 13h6" />
                                </svg>
                            </span>

                            Remark
                        </label>

                        <textarea
                            id="remark"
                            name="remark"
                            placeholder="Enter Remark"
                            value={formData.remark}
                            onChange={handleChange}
                            rows={3}
                            className="mt-2 block w-full rounded-md border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm resize-none"
                        />



                    </div>




                    </div>

                    {/* Submit Button */}
                    <div className="mt-6 text-right">
                        <button
                            type="submit"
                            className="inline-flex items-center gap-2 px-6 py-2 bg-indigo-600 text-white text-sm font-medium rounded-md shadow hover:bg-indigo-700 transition-all"
                        >
                            Update
                        </button>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default PayoutEdit
